// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {
  display: block;
  position: relative !important;
  top: 7px !important;
}

::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.59375em) scale(0.75);
  width: 133.33333%;
  position: relative;
  top: 13px !important;
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

::ng-deep.agent_form_field .mat-form-field-infix {
  padding: 0% !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

.configtable td {
  padding: 1% !important;
}

.configtable tr:hover {
  background-color: #f3eded;
  cursor: pointer;
}

.agentfilter_feild {
  width: 94% !important;
}

.active_table {
  background-color: rgba(23, 162, 184, 0.231372549);
}

.text-ellipsis {
  max-width: 83%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.configbtn_style {
  border: none;
  border-top: 34px solid #fafafa !important;
  border-right: 34px solid #17a0b4 !important;
  border-bottom: 34px solid #fafafa !important;
  border-left-color: #17a0b4 !important;
}

.addconfigbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
  cursor: pointer;
}

.dot {
  height: 22px;
  width: 25px;
  background-color: #17a0b4 !important;
  border-radius: 50%;
  display: inline-block;
}

.label_style {
  display: block;
  margin-block: 1%;
  font-size: 12px !important;
}

.font_text {
  font-size: 12px !important !important;
}

.search_control_version1 {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
}

.description {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/routeversion1/routeversion1.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,6BAAA;EACA,mBAAA;AADJ;;AAIE;EACE,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AADJ;;AAGE;EACE,WAAA;AAAJ;;AAGE;EACE,0BAAA;AAAJ;;AAEE;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;AACJ;;AAEE;EACE,sBAAA;AACJ;;AACE;EACE,yBAAA;EACA,eAAA;AAEJ;;AAAE;EACE,qBAAA;AAGJ;;AADE;EACE,iDAAA;AAIJ;;AAFE;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAKJ;;AAHE;EACE,YAAA;EACA,yCAAA;EACA,2CAAA;EACA,4CAAA;EACA,qCAAA;AAMJ;;AAJE;EACE,oCCtDQ;EDuDR,0BCtDO;EDuDP,YAAA;EACA,uBCtDQ;EDuDR,iBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAOJ;;AALE;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,qBAAA;AAQJ;;AANE;EACE,cAAA;EACA,gBAAA;EACA,0BCxEO;ADiFX;;AAPE;EACE,qCAAA;AAUJ;;AARE;EACE,uBC3ES;ED4ET,0BC/EO;EDgFP,oDAAA;EACA,kBAAA;AAWJ;;AATE;EACE,0BCpFO;ADgGX","sourcesContent":["\r\n@import \"../../variables.scss\";\r\n::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {\r\n    display: block;\r\n    position: relative !important;\r\n    top: 7px !important;\r\n  }\r\n\r\n  ::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n    transform: translateY(-1.59375em) scale(.75);\r\n    width: 133.33333%;\r\n    position: relative;\r\n    top: 13px !important;\r\n  }\r\n  .agent_form_field{\r\n    width: 100%;\r\n\r\n  }\r\n  .agent_form_field input{\r\n    font-size: 12px!important;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-infix{\r\n    padding: 0%!important;\r\n    padding-bottom: 7px!important;\r\n    padding-top: 2px!important;\r\n  }\r\n\r\n  .configtable td {\r\n    padding: 1% !important;\r\n  }\r\n  .configtable tr:hover {\r\n    background-color: #f3eded;\r\n    cursor: pointer;\r\n  }\r\n  .agentfilter_feild{\r\n    width:94%!important\r\n  }\r\n  .active_table {\r\n    background-color: #17a2b83b;\r\n  }\r\n  .text-ellipsis{\r\n    max-width: 83%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n  .configbtn_style {\r\n    border: none;\r\n    border-top: 34px solid #fafafa !important;\r\n    border-right: 34px solid #17a0b4 !important;\r\n    border-bottom: 34px solid #fafafa !important;\r\n    border-left-color: #17a0b4 !important;\r\n  }\r\n  .addconfigbtn{\r\n    background-color:$btn-color;\r\n    font-size: $fontsize;\r\n    color:white ;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n    cursor: pointer;\r\n  }\r\n  .dot {\r\n    height: 22px;\r\n    width: 25px;\r\n    background-color: #17a0b4 !important;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n  }\r\n  .label_style{\r\n    display: block;\r\n    margin-block: 1%;\r\n    font-size: $fontsize;\r\n  }\r\n  .font_text{\r\n    font-size:$fontsize !important;\r\n  }\r\n  .search_control_version1{\r\n    height:$inputHeight;\r\n    font-size:$fontsize;\r\n    box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    border-radius: 5px;\r\n  }\r\n  .description{\r\n    font-size: $fontsize;\r\n  }","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
